export const text = {
  title: 'Profile',
  editProfile: 'Edit Profile',
};
